import { Backdrop } from "@mui/material";
import Lottie from "lottie-react";
import { ColorScheme } from "../../Themes/ColorScheme";

export const BackdropLoading = () => (
	<Backdrop
		sx={{
			backgroundColor: ColorScheme.transparent,
			zIndex: (theme) => theme.zIndex.drawer + 1
		}}
		open={true}
	>
		<Lottie
			style={{ height: "100px", width: "100px" }}
			animationData={require("../../Assets/Other/loading.json")}
		/>
	</Backdrop>
);
